<template>
  <div class="table-of-contents">
    <div
      v-for="form in forms"
      :key="form.id"
      :class="classesForItem(form)"
      @click="setOfferFormId(form.id)"
    >
      {{ form.name }}
    </div>
    <a
      href="https://1cbo.ru/rates_and_services/offer2/"
      class="table-of-contents__item"
      target="_blank"
    >
      Правила обслуживания
      <img src="@icons/external-link.svg" alt="external-link.svg" />
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ContractOfferTableOfContents",

  computed: {
    ...mapGetters({
      forms: "Organizations/ActiveOne/getContractOfferForms",
      selectedFormId: "Organizations/ActiveOne/getOfferFormId",
    }),

    classesForItem() {
      return (form) => ({
        "table-of-contents__item": true,
        "table-of-contents__item--active": this.selectedFormId == form.id,
        "table-of-contents__item--inactive": !form.available,
      });
    },
  },

  methods: {
    ...mapActions({
      setOfferFormId: "Organizations/ActiveOne/setOfferFormId",
    }),
  },
};
</script>

<style scoped lang="scss">
.table-of-contents {
  width: 100%;
  padding: 15px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);

  &__item {
    display: flex;
    width: 100%;
    height: 46px;
    align-items: center;
    padding-left: 20px;
    color: $black;
    cursor: pointer;
    font-size: 18px;

    &--active {
      border-radius: 10px;
      background: $grey-100;
      font-weight: 500;
    }

    &--inactive {
      color: $grey-400;
      cursor: auto;
      pointer-events: none;
      user-select: none;
    }

    img {
      width: 16px;
      height: 16px;
      margin-left: 8px;
    }
  }
}
</style>
